// Pure helpers for rendering an invoice. Kept OUT of the InvoicePreview component so they are
// testable: that component pulls CSS modules, @fontsource and MUI icons, none of which jest can
// transform, so anything importing it is untestable.

/**
 * Find the catalog item an invoice line is for, so the checkout summary can show its thumbnail.
 *
 * PREFER `itemType`. The backend stamps each PRODUCT line with its ItemType
 * (InvoiceItemDto.itemType). It is absent on synthetic lines (shipping, discounts, adjustments,
 * unlock-code placeholders) and on invoices stored before that field existed — hence the fallback.
 *
 * The fallback is the original rule: match the line's free text against a catalog name. That only
 * works while the backend's display name and the catalog name stay in sync, and they had already
 * drifted for BOTH R295 wheels — the backend says "R295 G2 Steering Wheel" while the catalog says
 * "R295 G2 GT & Formula Steering Wheel" — so neither wheel ever rendered a thumbnail. Keep it only
 * for old invoices; everything new resolves by type.
 *
 * @param {string|null|undefined} itemType     InvoiceItemDto.itemType, e.g. 'R295_STEERING_WHEEL_G2'
 * @param {string|null|undefined} description  the invoice line's free text
 * @param {Array<any>|null|undefined} shopItems the region's joined catalog
 * @returns {any|undefined} the matching shop item, or undefined (line renders with no image)
 */
export const findInvoiceLineItem = (itemType, description, shopItems) => {
  if (!shopItems) return undefined
  if (itemType) {
    const byType = shopItems.find(s => s.type === itemType)
    if (byType) return byType
  }
  return description ? shopItems.find(s => s.name && description.includes(s.name)) : undefined
}
